import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, pick } from 'lodash';
import scrollToComponent from 'react-scroll-to-component';
import Logo from './Logo';
import { Context as AppContext } from '../contexts/AppContext';
import useGroups from '../hooks/useGroups';
import RegisterForm from './RegisterForm';
import useRegister from '../hooks/useRegister';
import useAuthWithKey from '../hooks/useAuthWithKey';
import { appPath } from '../lib/consts';
import { formatPhoneNumber } from '../lib/utils';

const Base = styled.div`
  /* width: 400px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    align-self: center;
    max-height: 20%;
    width: 60%;
    margin-bottom: 1.25em;
  }
  width: 100%;
  form {
    /* width: 400px; */
    margin-bottom: 1.5rem;

    .field-radio-group {
      .radio-inline {
        margin-right: 1em;
        input {
          margin-right: 0.3em;
        }
      }
    }
    .buttons {
      text-align: right;
    }
    > .errors {
      display: none;
    }
  }
`;

const ContactInfo = styled.div`
  font-size: 0.9em;
  margin-top: 1.5rem;
  padding-top: 2.25rem;
  border-top: 1px solid gray;
  line-height: 110%;
  h6 {
    font-size: 1.2em;
    font-weight: bold;
  }
  label:after {
    content: ':';
    margin-right: 0.3em;
  }
  .gu {
    .logo {
      height: 3.75rem;
      background-position-x: left !important;
    }
  }
`;

export default function Register({ match, history }) {
  const {
    client, token,
    setToken, setMemberships,
    registerFormData, setRegisterFormData, resetRegisterFormData,
    insertToast,
  } = useContext(AppContext);
  const topRef = useRef();
  const reviewMode = !!get(match, 'path', '').match(/\/review$/);
  const key = get(match, 'params.key');
  const groupId = get(match, 'params.groupId');
  const { token: tokenFromKey } = useAuthWithKey({ client, key });
  // const preferredContactMethod = get(registerFormData, 'preferredContactMethod');
  // useEffect(() => {
  //   if (preferredContactMethod === preferredContactMethods.none.value) {
  //     setRegisterFormData({
  //       ...registerFormData,
  //       email: '',
  //       phone: '',
  //       emailConfirmation: '',
  //     });
  //   }
  // }, [preferredContactMethod]);
  useEffect(() => {
    if (tokenFromKey) setToken(tokenFromKey, { path: appPath });
  }, [tokenFromKey]);
  const { register, registerResult, clearRegisterResult } = useRegister({ client });
  const { currentEntity, setCurrentEntityId, policies } = useGroups({ client });
  useEffect(() => { setCurrentEntityId(groupId); }, [groupId]);
  const {
    website, phone, email, logo,
  } = pick(currentEntity, ['website', 'phone', 'email', 'logo', 'config']);
  useEffect(() => {
    if (registerResult) {
      if (registerResult.success) {
        setMemberships(registerResult.data);
        history.push(`/${groupId}/memberships/${registerResult.data.id}`);
        resetRegisterFormData();
        clearRegisterResult();
      } else {
        insertToast({
          title: 'Failed',
          body: registerResult.message,
        });
      }
    }
  }, [registerResult]);
  if (!token) {
    return (
      <Base>
        <Logo url={logo} />
        {
          !key && (
            <center>
              <a
                href={`/login/?from=${encodeURIComponent(window.location)}`}
                className="btn btn-primary"
                style={{ width: 100 }}
              >
              Login
              </a>
            </center>
          )
        }
      </Base>
    );
  }
  return (
    currentEntity ? (
      <Base>
        <Logo url={logo} />
        <div ref={topRef} />
        <RegisterForm
          registerFormData={registerFormData}
          setRegisterFormData={setRegisterFormData}
          resetRegisterFormData={resetRegisterFormData}
          group={currentEntity}
          policies={policies}
          reviewMode={reviewMode}
          onReview={() => {
            if (topRef.current) {
              scrollToComponent(topRef.current);
            }
            history.push(`/${groupId}/register/review`);
          }}
          onBack={() => {
            history.goBack();
          }}
          onSubmit={register}
        />
        <ContactInfo>
          <h6>Contact Information</h6>
          <div>
            <label>E-mail</label>
            <span>
              <a href={`mailto:${email}`}>
                {email || 'n/a'}
              </a>
            </span>
          </div>
          <div>
            <label>Phone</label>
            <span>
              <a href={`tel:${phone}`}>
                {formatPhoneNumber(phone) || 'n/a'}
              </a>
            </span>
          </div>
          <div>
            <label>Website</label>
            <span>
              <a href={website}>
                {website || 'n/a'}
              </a>
            </span>
          </div>
          <div>
            <a href={`/login/?from=${encodeURIComponent(window.location)}&relogin=true`}>
              Re-Login
            </a>
          </div>
          <a hidden href="https://www.genrusunited.ca" className="gu"><Logo /></a>
        </ContactInfo>
      </Base>
    ) : (
      <Base>
        <Logo url={logo} />
        <center>
          <a
            href={`/login/?from=${encodeURIComponent(window.location)}`}
            className="btn btn-primary"
            style={{ width: 100 }}
          >
              Login
          </a>
        </center>
      </Base>
    )
  );
}

Register.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      groupId: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
